import React, { Component } from 'react';
import { VerificationForm } from '@sheerid/jslib';
import '@sheerid/jslib/sheerid.css';
import './App.css';

import { programId } from './programOptions';

class App extends Component {
    render() {
        const urlParams = new URLSearchParams(window.location.search);
        const trackingId = urlParams.get('trackingId');
        return (
            <div className="sid-verification-container">
                {trackingId ? <VerificationForm programId={programId} trackingId={trackingId}/> : <VerificationForm programId={programId}/>}
            </div>
        );
    }
}

export default App;
